const mutations = {
  'SET_EMAILS' (state, value) {
    state.emails = value
  }
}
  
export default mutations
